var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8 11.0108C28.8 12.3356 29.8752 13.4108 31.2 13.4108C31.6416 13.4108 32 13.0524 32 12.6108V4.7996C32 2.1484 29.8512 -0.000396729 27.2 -0.000396729H18.896C18.4528 -0.000396729 18.096 0.358003 18.096 0.799603C18.096 2.1244 19.1696 3.1996 20.496 3.1996H26.5379L15.9032 13.8343C15.5912 14.1463 15.5912 14.6535 15.9032 14.9655L17.0344 16.0967C17.3464 16.4087 17.8536 16.4087 18.1656 16.0967L28.8 5.46232V11.0108ZM24 31.9999H4.8C2.1488 31.9999 0 29.8511 0 27.1999V7.99992C0 5.34872 2.1488 3.19992 4.8 3.19992H10.8944C12.2208 3.19992 13.2944 4.27512 13.2944 5.59992V5.61592C13.2944 6.04792 12.944 6.39992 12.5104 6.39992H4.8C3.9168 6.39992 3.2 7.11512 3.2 7.99992V27.1999C3.2 28.0847 3.9168 28.7999 4.8 28.7999H24C24.8848 28.7999 25.6 28.0847 25.6 27.1999V19.9839C25.6 19.5519 25.952 19.1999 26.384 19.1999H26.4C27.7248 19.1999 28.8 20.2751 28.8 21.5999V27.1999C28.8 29.8511 26.6512 31.9999 24 31.9999Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon_share.0f9f0d10774ee917a2b234de508e9429.svg";
export { ForwardRef as ReactComponent };